"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUSPICIOUS_PAYMENT_FUNDING_TYPES = exports.WIRE_TRANSFER_FUNDING_TYPES = exports.PaymentFundingType = exports.PortalBalanceTransferStatus = exports.MIN_MONTHLY_PAYMENT_AMOUNT_IN_DOLLARS = exports.AvenPaymentAllocationRequestStatus = exports.AvenPaymentAllocationRequestType = exports.AvenPaymentAllocationPattern = void 0;
var AvenPaymentAllocationPattern;
(function (AvenPaymentAllocationPattern) {
    AvenPaymentAllocationPattern["coreCardDefault"] = "coreCardDefault";
    AvenPaymentAllocationPattern["avenGracePeriodSupport"] = "avenGracePeriodSupport";
    AvenPaymentAllocationPattern["payDownAllPlans"] = "payDownAllPlans";
    AvenPaymentAllocationPattern["custom"] = "custom";
    AvenPaymentAllocationPattern["TESTING_ONLY_payAllPlansEqually"] = "TESTING_ONLY_payAllPlansEqually";
})(AvenPaymentAllocationPattern || (exports.AvenPaymentAllocationPattern = AvenPaymentAllocationPattern = {}));
var AvenPaymentAllocationRequestType;
(function (AvenPaymentAllocationRequestType) {
    AvenPaymentAllocationRequestType["payment"] = "PAYMENT";
    AvenPaymentAllocationRequestType["reversal"] = "REVERSAL";
})(AvenPaymentAllocationRequestType || (exports.AvenPaymentAllocationRequestType = AvenPaymentAllocationRequestType = {}));
var AvenPaymentAllocationRequestStatus;
(function (AvenPaymentAllocationRequestStatus) {
    AvenPaymentAllocationRequestStatus["requested"] = "REQUESTED";
    AvenPaymentAllocationRequestStatus["fulfilled"] = "FULFILLED";
    AvenPaymentAllocationRequestStatus["bailRequested"] = "BAIL_REQUESTED";
    AvenPaymentAllocationRequestStatus["bailing"] = "BAILING";
    AvenPaymentAllocationRequestStatus["bailed"] = "BAILED";
})(AvenPaymentAllocationRequestStatus || (exports.AvenPaymentAllocationRequestStatus = AvenPaymentAllocationRequestStatus = {}));
exports.MIN_MONTHLY_PAYMENT_AMOUNT_IN_DOLLARS = 25;
/**
 * Simplified balance transfer status for portal users.
 */
var PortalBalanceTransferStatus;
(function (PortalBalanceTransferStatus) {
    PortalBalanceTransferStatus["PendingCardholderApproval"] = "PendingCardholderApproval";
    PortalBalanceTransferStatus["Processing"] = "Processing";
    PortalBalanceTransferStatus["Completed"] = "Completed";
    PortalBalanceTransferStatus["Canceled"] = "Canceled";
    PortalBalanceTransferStatus["Failed"] = "Failed";
})(PortalBalanceTransferStatus || (exports.PortalBalanceTransferStatus = PortalBalanceTransferStatus = {}));
var PaymentFundingType;
(function (PaymentFundingType) {
    PaymentFundingType["ACH"] = "ACH";
    PaymentFundingType["DEBIT_CARD"] = "DC";
    // From real world testing, debit cards are showing up as 'CC' now. Support it now
    PaymentFundingType["CREDIT_CARD"] = "CC";
    PaymentFundingType["ELOCKBOX"] = "ELOCKBOX";
    PaymentFundingType["BALLOON_INTERNAL_PAYOFF"] = "BALLOON_INTERNAL_PAYOFF";
    /** @deprecated Crypto liquidation payments go directly from BitGo to CoreCard, bypassing ACI. */
    PaymentFundingType["CRYPTO_LIQUIDATION"] = "CRYPTO_LIQUIDATION";
    PaymentFundingType["WIRE_TRANSFER"] = "WIRE_TRANSFER";
    PaymentFundingType["WIRE_TRANSFER_PAYOFF"] = "WIRE_TRANSFER_PAYOFF";
    PaymentFundingType["CHECK"] = "CHECK";
    PaymentFundingType["CHECK_PAYOFF"] = "CHECK_PAYOFF";
    PaymentFundingType["CERTIFIED_CHECK"] = "CERTIFIED_CHECK";
    PaymentFundingType["CERTIFIED_CHECK_PAYOFF"] = "CERTIFIED_CHECK_PAYOFF";
    PaymentFundingType["THIRD_PARTY_COLLECTIONS"] = "THIRD_PARTY_COLLECTIONS";
})(PaymentFundingType || (exports.PaymentFundingType = PaymentFundingType = {}));
exports.WIRE_TRANSFER_FUNDING_TYPES = [PaymentFundingType.WIRE_TRANSFER, PaymentFundingType.WIRE_TRANSFER_PAYOFF];
// https://docs.google.com/document/d/15juRE7XKbh2T3MsocRbciCWlZ-eiaOwDSGidxe_5VHE/edit?tab=t.0
exports.SUSPICIOUS_PAYMENT_FUNDING_TYPES = Object.values(PaymentFundingType).filter((type) => !exports.WIRE_TRANSFER_FUNDING_TYPES.includes(type) && type !== PaymentFundingType.BALLOON_INTERNAL_PAYOFF);
